//SYSTEM
export const REQUEST_ALLOW = 'REQUEST_ALLOW'
export const GAME_BANNER_ID = 'GAME_BANNER_ID'
export const MOREBETLOADING = 'MOREBETLOADING'
export const MOREBETTOGGLE = 'MOREBETTOGGLE'
export const RESIZE_WHEIGHT = 'RESIZE_WHEIGHT'

//ACCOUNT
export const ACCOUNT = 'ACCOUNT'
export const SELECTED_ODD = 'SELECTED_ODD'
export const TIME_ZONE  = 'TIME_ZONE'
export const ACCOUNT_FAV  = 'ACCOUNT_FAV'

//SPORT
export const EVENTLIST = 'EVENTLIST'
export const RBEVENTLIST = 'RBEVENTLIST'
export const FAVRBEVENTLIST = 'FAVRBEVENTLIST'
export const EVENT_ALLBET = 'EVENT_ALLBET'
export const MAINMARKET_BET = 'MAINMARKET_BET'
export const MATCH_ALLBET = 'MATCH_ALLBET'
export const SHOWHIDE_EVENTLIST = 'SHOWHIDE_EVENTLIST'
export const SHOWHIDE_RBEVENTLIST = 'SHOWHIDE_RBEVENTLIST'
export const SHOW_LEAGUETEAM = 'SHOW_LEAGUETEAM'
export const SORTEDEVENTLIST = 'SORTEDEVENTLIST'
export const SORTEDRBEVENTLIST = 'SORTEDRBEVENTLIST'
export const OTRSPORTLIST = 'OTRSPORTLIST'
export const SORTEDFAVRBEVENTLIST = 'SORTEDFAVRBEVENTLIST'
export const SORTEDMATCHEVENTLIST = 'SORTEDMATCHEVENTLIST'
export const FIRSTEVENT = 'FIRSTEVENT'
export const TESTSHOW = 'TESTSHOW'
export const SHOWRIGHTBANNER = 'SHOWRIGHTBANNER'
export const FAVOURITEEVENT = 'FAVOURITEEVENT'
export const FAVOURITEEVENT_FIRSTLOAD = 'FAVOURITEEVENT_FIRSTLOAD'
export const FAVOURITEOTREVENT = 'FAVOURITEOTREVENT'
export const FAVOURITEOTREVENTCOUNT = 'FAVOURITEOTREVENTCOUNT'
export const FAVOURITEEVENTCOUNT = 'FAVOURITEEVENTCOUNT'
export const FAVOURITERBEVENTCOUNT = 'FAVOURITERBEVENTCOUNT'
export const FAVOURITELGEVENT = 'FAVOURITELGEVENT'
export const FAVOURITELGEVENT_FIRSTLOAD = 'FAVOURITELGEVENT_FIRSTLOAD'
export const TOTALPAGE = 'TOTALPAGE'
export const SPORTLIST = 'SPORTLIST'
export const ASPORTLIST = 'ASPORTLIST'
export const BETTYPELIST = 'BETTYPELIST'
export const SPORTBETTYPELIST = 'SPORTBETTYPELIST'
export const ODDTYPESLIST = 'ODDTYPESLIST'
export const EARLYPARLAYDATELIST = 'EARLYPARLAYDATELIST'
export const SELECTEDEARLYPARLAYDATE = 'SELECTEDEARLYPARLAYDATE'
export const TOTALLEAGUES = 'TOTALLEAGUES'
export const SELECTEDLEAGUES = 'SELECTEDLEAGUES'
export const SELECTED_PAGE = 'SELECTED_PAGE'
export const SELECTED_PER_PAGE = 'SELECTED_PER_PAGE'
export const SELECTED_MATCHALLBET = 'SELECTED_MATCHALLBET'
export const SELECTED_ALLBET = 'SELECTED_ALLBET'
export const SELECTED_ALLBETNEW = 'SELECTED_ALLBETNEW'
export const SELECTED_SORT = 'SELECTED_SORT'
export const SELECTED_SHOW = 'SELECTED_SHOW'
export const SELECTED_SPORT = 'SELECTED_SPORT'
export const SELECTED_BETTYPE = 'SELECTED_BETTYPE'
export const SELECTED_PLYTYPE = 'SELECTED_PLYTYPE'
export const SELECTED_MARKET = 'SELECTED_MARKET'
export const CHANGE_ODDS = 'CHANGE_ODDS'
export const SPORTTABLELANG = 'SPORTTABLELANG'
export const SPORTALLBETLANG = 'SPORTALLBETLANG'
export const SPORT_LEAGUE_TOGGLE = 'SPORT_LEAGUE_TOGGLE'
export const SPORT_FULLHALF_TIME = 'SPORT_FULLHALF_TIME'
export const SPORT_INPLAY_EVENTS = 'SPORT_INPLAY_EVENTS'
export const SPORT_ALL_EVENTS = 'SPORT_ALL_EVENTS'
export const SPORT_SHOW_FAV_EVENTS = 'SPORT_SHOW_FAV_EVENTS'
export const SPORT_PREVIOUS_IS_MULP = 'SPORT_PREVIOUS_IS_MULP'
export const SPORT_MAPPING_BETTING = 'SPORT_MAPPING_BETTING'
export const GAMEBANNER_SELECTED = 'GAMEBANNER_SELECTED'
export const SPORTLEAGUE_WINDOWEVENT = 'SPORTLEAGUE_WINDOWEVENT'
export const OPEN_RBMARKET = 'OPEN_RBMARKET'
export const SELECTED_INPLAYSPORT = 'SELECTED_INPLAYSPORT'
export const ALLBET_RELOADING = 'ALLBET_RELOADING'
export const R_ALLBET_RELOADING = 'R_ALLBET_RELOADING'
export const EARLYCOUNT_BYDATE = 'EARLYCOUNT_BYDATE'
export const UNFOLD_ALLSC = 'UNFOLD_ALLSC'
export const SHOW_UNFOLD = 'SHOW_UNFOLD'
export const SHOW_FOLD = 'SHOW_FOLD'
export const SELECTED_ALLBETTAB = 'SELECTED_ALLBETTAB'
export const FOLDOPEN_FIRSTEVENT= 'FOLDOPEN_FIRSTEVENT'
export const SHOW_RBLGEEVE= 'SHOW_RBLGEEVE'
export const SHOW_LGEEVE= 'SHOW_LGEEVE'
export const IS_CHANGE_TEMPLATE = 'IS_CHANGE_TEMPLATE'
export const SELECTED_EVEID = 'SELECTED_EVEID'
export const IS_PARLAY_TAB = 'IS_PARLAY_TAB'
export const PREV_BETTYPE = 'PREV_BETTYPE'
export const GAME_BANNER_SPORT_ID = 'GAME_BANNER_SPORT_ID'
export const GAME_BANNER_SPORT_COUNT = 'GAME_BANNER_SPORT_COUNT'
export const RIGHT_BOARD_CHG = 'RIGHT_BOARD_CHG'
export const SIMPLE_SPORT = 'SIMPLE_SPORT'
export const STATE_LIST = 'STATE_LIST'
export const HOT_SCHEDULE = 'HOT_SCHEDULE'
export const HOT_SPORTLIST = 'HOT_SPORTLIST'

//BET
export const BETLANG = 'BETLANG'
export const BETTYPELANG = 'BETTYPELANG'
export const LEAGUELIST = 'LEAGUELIST'
export const MERGE_LEAGUELIST = 'MERGE_LEAGUELIST'
export const ODD_SELECTED = 'ODD_SELECTED'
export const BET_FORM = 'BET_FORM'
export const SELECTED_LEAGUELIST = 'SELECTED_LEAGUELIST'
export const REMOVE_MATCH = 'REMOVE_MATCH'
export const BETTING_CHIP_OPTION = 'BETTING_CHIP_OPTION'
export const BETTING_BETAMOUNT_OPTION = 'BETTING_BETAMOUNT_OPTION'
export const BETTING_MESSAGE = 'BETTING_MESSAGE'
export const BETTING_ALLUP = 'BETTING_ALLUP'
export const BETTING_DELAY_TIMERID = 'BETTING_DELAY_TIMERID'
export const HIGHLIGHT_CELL = 'HIGHLIGHT_CELL'
export const PARLAY_SELECTED = 'PARLAY_SELECTED'
export const OPEN_BETFORM = 'OPEN_BETFORM'
export const BET_AMOUNT = 'BET_AMOUNT'
export const SHOW_BETFORM_MENU = 'SHOW_BETFORM_MENU'
export const BETFORM_HDPCHG = 'BETFORM_HDPCHG'
export const BETFORM_ODDCHG = 'BETFORM_ODDCHG'
export const IS_BETCOMBO = 'IS_BETCOMBO'
export const COMBOBET_EXCEEDLIMIT = 'COMBOBET_EXCEEDLIMIT'
export const BETCOMBO_AMOUNT = 'BETCOMBO_AMOUNT'
export const BETCOMBO_ERROR = 'BETCOMBO_ERROR'
export const BETCOMBO_MESSAGE = 'BETCOMBO_MESSAGE'
export const BETCOMBO_KEYBOARDALLOW = 'BETCOMBO_KEYBOARDALLOW'
export const CLEAR_BET_SUCCESS = 'CLEAR_BET_SUCCESS'
export const REMOVE_ALLBUTLAST = 'REMOVE_ALLBUTLAST'
export const RESET_BET_COMBO_ARRAY = 'RESET_BET_COMBO_ARRAY'
export const SET_MATCH_INDEX_NO_ERR = 'SET_MATCH_INDEX_NO_ERR'
export const ALLOW_ERR_BET_AGAIN = 'ALLOW_ERR_BET_AGAIN'
export const BETMULP_AMOUNT = 'BETMULP_AMOUNT'
export const BETMULP_AMOUNT_FILTERED = 'BETMULP_AMOUNT_FILTERED'
export const DISABLE_BET = 'DISABLE_BET'
export const DIALOG_TOGGLE = 'DIALOG_TOGGLE'
export const SELECTED_MULP_BOX = 'SELECTED_MULP_BOX'


//SPORTEVENT
export const SPORTRESULT_LANG = 'SPORTRESULT_LANG'
export const SPORTRESULT_DATELIST = 'SPORTRESULT_DATELIST'

//SPORT FORECAST
export const SPORTFORECAST_LANG = 'SPORTFORECAST_LANG'
export const SPORTFORECAST_TOGGLE = 'SPORTFORECAST_TOGGLE'
export const SPORTFORECAST_SELECTEDEVENT = 'SPORTFORECAST_SELECTEDEVENT'
export const SPORTFORECAST_WINDOWEVENT = 'SPORTFORECAST_WINDOWEVENT'
export const SPORTFORECAST_LIST = 'SPORTFORECAST_LIST'
export const SPORTFORECAST_WAITINGLIST = 'SPORTFORECAST_WAITINGLIST'

//SPORT MINIBET
export const SPORT_MINIBET = 'SPORT_MINIBET'
export const SPORT_MINIBET_TOGGLE = 'SPORT_MINIBET_TOGGLE'
export const SPORT_MINIBET_WINDOWEVENT = 'SPORT_MINIBET_WINDOWEVENT'
export const SPORT_MINIBET_BETAMOUNT = 'SPORT_MINIBET_BETAMOUNT'
export const SPORT_MINIBET_RIGHTSIDE = 'SPORT_MINIBET_RIGHTSIDE'

//STATEMENT
export const STATEMENT_DATELIST = 'STATEMENT_DATELIST'
export const STATEMENT_LIST = 'STATEMENT_LIST'
export const STATEMENT_WAGERLIST = 'STATEMENT_WAGERLIST'
export const STATEMENT_LAST10_WAGERLIST = 'STATEMENT_LAST10_WAGERLIST'
export const STATEMENT_SELECTED_SPORT = 'STATEMENT_SELECTED_SPORT'
export const STATEMENT_SELECTED_DATE = 'STATEMENT_SELECTED_DATE'
export const STATEMENT_SELECTED_WAGER_DATE = 'STATEMENT_SELECTED_WAGER_DATE'
export const STATEMENT_SELECTED_WAGER_PAGE = 'STATEMENT_SELECTED_WAGER_PAGE'
export const STATEMENT_SHOW_WAGERDETAIL = 'STATEMENT_SHOW_WAGERDETAIL'
export const STATEMENT_WAGER_TYPE = 'STATEMENT_WAGER_TYPE'
export const STATEMENT_SHOW_STATEMENT = 'STATEMENT_SHOW_STATEMENT'
export const SELECTED_TAB = 'SELECTED_TAB'
export const SATEMENT_IS_CANCELWAGER = 'SATEMENT_IS_CANCELWAGER'
export const STATEMENT_DATE_RANGE = 'STATEMENT_DATE_RANGE'
export const STATEMENT_API_DATELIST = 'STATEMENT_API_DATELIST'
export const STATEMENT_SELECTED_WEEK = 'STATEMENT_SELECTED_WEEK'
export const STATEMENT_SHOW_LEDGER = 'STATEMENT_SHOW_LEDGER'
export const STATEMENT_DETAIL = 'STATEMENT_DETAIL'
export const API_WAGER_DETAIL = 'API_WAGER_DETAIL'

//LEAGUE
export const COOKIE_LEAGUE = 'COOKIE_LEAGUE'
export const SELECT_ALL_LEAGUE = 'SELECT_ALL_LEAGUE'
export const SEARCH_LEAGUE = 'SEARCH_LEAGUE'
export const SHOW_LEAGUESEARCH= 'SHOW_LEAGUESEARCH'

//LIVE CHANNEL
export const LIVE_EVENT = 'LIVE_EVENT'
export const LIVE_SELECTED_EVENT = 'LIVE_SELECTED_EVENT'
export const LIVE_SPORT_TITLE = 'LIVE_SPORT_TITLE'
export const LIVE_SCHECULE = 'LIVE_SCHECULE'
export const LIVE_ALLBET = 'LIVE_ALLBET'
export const LIVE_MATCH = 'LIVE_MATCH'
export const IS_OPEN_TV = 'IS_OPEN_TV'

export const ALLSPORTCOUNT = 'ALLSPORTCOUNT'
export const BET_SUCCESS = 'BET_SUCCESS'
export const PROCESS_BET = 'PROCESS_BET'
export const CHECKED_BALANCE = 'CHECKED_BALANCE'
export const FOLDOPEN_ALLBET = 'FOLDOPEN_ALLBET'
export const IS_TODAYRB = 'IS_TODAYRB'
export const PLACED_BET = 'PLACED_BET'
export const PENDING_FLAG = 'PENDING_FLAG'
export const IS_REFUND = 'IS_REFUND'
export const JS_ERR = 'JS_ERR'
export const BETCOMBO_JS_ERR = 'BETCOMBO_JS_ERR'
export const BETLIST_TYPE = 'BETLIST_TYPE'
export const SHOWRES_BOX = 'SHOWRES_BOX'
export const SELECTED_BETTAB = 'SELECTED_BETTAB'
export const LIVETV  = 'LIVETV'

//Resize
export const MINI_NORMAL = 'MINI_NORMAL'
export const FRAME_WH = 'FRAME_WH'
export const FRAME_RESIZE = 'FRAME_RESIZE'

// Search League
export const COOKIE_HISTORY = 'COOKIE_HISTORY'
export const SEARCH_LOADING = 'SEARCH_LOADING'
export const HIST_LIST = 'HIST_LIST'
export const FILTER_EVENT = 'FILTER_EVENT'

// Promotion
export const PROMO_JOINED_FLAG = 'PROMO_JOINED_FLAG'
export const PROMO_FLAG = 'PROMO_FLAG'
export const PROMO_DETAILS = 'PROMO_DETAILS'
export const PROMO_SHOW_JOIN_SUCCESS = 'PROMO_SHOW_JOIN_SUCCESS'
export const PROMO_BET_STATUS = 'PROMO_BET_STATUS'
export const PROMO_BET_INDEX = 'PROMO_BET_INDEX'
export const PROMO_BET_WITHOUT_JOIN = 'PROMO_BET_WITHOUT_JOIN'
export const STATEMENT_SHOW_PROMOTIONDETAIL = 'STATEMENT_SHOW_PROMOTIONDETAIL'
export const PROMO_WAGER_DETAIL = 'PROMO_WAGER_DETAIL'
export const PROMO_PROMPT_CONFIRM = 'PROMO_PROMPT_CONFIRM'




// WEBPACK FOOTER //
// ./resources/wob/vue/store/mutation-types.js